import { render, staticRenderFns } from "./Theory.vue?vue&type=template&id=c6d9c9f0&"
import script from "./Theory.vue?vue&type=script&lang=js&"
export * from "./Theory.vue?vue&type=script&lang=js&"
import style0 from "./Theory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports